// src/pages/Login/LoginPage.js
// This is the Login Page component.
// It features a "glass" form for email and password.

import React, { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom"; // Use Link for navigation
import "./Login.css"; 
import { gsap } from "gsap"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function LoginPage() {
  const formRef = useRef(null);
  
  // Simple fade-in animation
  useLayoutEffect(() => {
    document.title = "Login | Dandelion Run Community";
    gsap.fromTo(
      formRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  // This is a placeholder for your friend's login logic
  const handleLogin = (event) => {
    event.preventDefault();
    // This is where your friend will add the code to log the user in.
    // We'll just show a "coming soon" message for now.
    toast.info("Login feature is coming soon!");
  };
  
  return (
    // The main container with the Hero background image
    <section className="login-page-section">
      
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        theme="dark"
      />

      {/* --- The "Glass" Form Container --- */}
      <div className="glass-form-container" ref={formRef}>
        
        <form 
          name="login"
          method="POST" 
          onSubmit={handleLogin}
        >
          <h2 className="login-title">Login</h2>
          
          {/* --- Email (Required) --- */}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required 
            />
          </div>
          
          {/* --- Password (Required) --- */}
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              required 
            />
          </div>
          
          {/* --- Submit Button --- */}
          <button type="submit" className="login-submit-button">
            Login
          </button>
          
          {/* --- Link to Sign Up Page --- */}
          <div className="signup-link">
            <p>
              Don't have an account? 
              <Link to="/signup"> Sign up here</Link>
            </p>
          </div>
          
        </form>
      </div>
      
    </section>
  );
}

export default LoginPage;